;(function(root) {
  const $pricingToggleOptions = $('.pricing-three-column-panel__toggle-switch-options'),
    $pricingToggleAnnually = $('.js-pricing-three-column-panel-toggle-annually'),
    $pricingToggleMonthly = $('.js-pricing-three-column-panel-toggle-monthly'),
    $pricingGroup = $('.pricing-three-column-panel__price-group')

  function init() {
    attachEvents()
  }

  function attachEvents() {
    $pricingToggleMonthly.on('click', () => {
      updatePricingToggle(false)
    })

    $pricingToggleAnnually.on('click', () => {
      updatePricingToggle(true)
    })
  }

  function updatePricingToggle(isAnnually) {
    if (isAnnually) {
      $pricingToggleOptions.removeClass('-monthly').addClass('-annually')
      $('.-annually', $pricingGroup).show()
      $('.-monthly', $pricingGroup).hide()
      return
    }
    $pricingToggleOptions.removeClass('-annually').addClass('-monthly')
    $('.-annually', $pricingGroup).hide()
    $('.-monthly', $pricingGroup).show()
  }

  init()
})(window)
